//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';

export default {
  name: 'DpIndicator',
  mixins: [Tooltip],
  props: {
    rightOffset: { type: Number, default: -5 },
    topOffset: { type: Number, default: 5 },
    noPositioning: { type: Boolean, default: false },
    defaultPosition: { type: Boolean, default: false },
    colourStyle: { type: String, default: null },
    size: { type: Number, default: null },
    draggable: { type: Boolean, default: false },
  },
  data() {
    return {
      dragStarted: false,
    };
  },
  computed: {
    style() {
      if (this.noPositioning) {
        return null;
      }

      const style = {
        right: `${this.rightOffset}px`,
        top: `${this.topOffset}px`,
      };

      if (this.size) {
        style.width = `${this.size}px`;
        style.height = `${this.size}px`;
      }

      if (this.colourStyle === 'primary') {
        style.background = '#3771d0';
        style.borderColor = '#E6EFFF';
      } else if (this.colourStyle === 'warning') {
        style.background = '#F5C256';
        style.borderColor = '#FFF7E6';
      } else if (this.colourStyle === 'error') {
        style.background = '#F14242';
        style.borderColor = '#FFEDED';
      }

      return style;
    },
  },
  mounted() {
    if (this.defaultPosition) {
      this.showTooltip();
      this.disableTooltip();
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
    dragstart(e) {
      this.$emit('dragstart', e);
    },
  },
};
